module.exports = __webpack_public_path__ + "static/media/project2.0c886491.png";